<div (click)="onContainerClicked($event)" class="deleteModal modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
     [ngStyle]="{'display': visible ? 'flex' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">CONFIRMATION</h4>
      </div>
      <div class="modal-body">
        <p class="delete-roaming-modal-content">{{text}}</p>
        <p class="delete-roaming-modal-content">Please confirm.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default impersonate-btn custom-btn transition" (click)="hide()">CANCEL</button>
        <button type="button" class="btn btn-primary custom-btn transition" (click)="deleteServer()">DELETE</button>
      </div>
    </div>
  </div>
</div>
